import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';

import TextField from '@gef-ui/form-material/TextField';
import MagnifyingGlass from '@gef-ui/material-icons/MagnifyingGlass';

export const TextFieldWithSearchIcon = ({
	fieldName,
	label,
	textFieldDisabled,
	onSearch,
	searchIconDisabled,
	maxLength,
	...rest
}) => {
	return (
		<TextField
			size="small"
			fieldName={fieldName}
			label={label}
			disabled={textFieldDisabled}
			slotProps={{
				htmlInput: {
					maxLength,
				},

				input: {
					endAdornment: (
						<IconButton sx={{ cursor: 'pointer' }} onClick={onSearch} disabled={searchIconDisabled}>
							<MagnifyingGlass />
						</IconButton>
					),
				},
			}}
			{...rest}
		/>
	);
};

TextFieldWithSearchIcon.propTypes = {
	fieldName: PropTypes.string,
	label: PropTypes.string,
	maxLength: PropTypes.number,
	onSearch: PropTypes.func,
	required: PropTypes.bool,
	searchIconDisabled: PropTypes.bool,
	textFieldDisabled: PropTypes.bool,
};

export default TextFieldWithSearchIcon;
